interface LoadingOverlayProps {
  message?: string;
}

export function LoadingOverlay({
  message = "Loading dictionary...",
}: LoadingOverlayProps) {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-lg text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
